'use strict';
import React from 'react';
import { Link } from 'react-router-dom';
import SideMenu from '../sideMenu';
import reportAction from '../../actions/reportAction';
import reportStore from '../../stores/reportStore';
import ReportModal from './reportModal';
import Loading from '../loading';

class ReportDetail extends React.Component {
    constructor(props) {
        super(props);
        this.extendIncident = this.extendIncident.bind(this);
        this.shouldModalClose = this.shouldModalClose.bind(this);
        this.resolveIncident = this.resolveIncident.bind(this);
        this.addingRemark = this.addingRemark.bind(this);
        this.removeIncident = this.removeIncident.bind(this);
        this.handleOption = this.handleOption.bind(this);
        this.handlePrint = this.handlePrint.bind(this);
        this.handleDL = this.handleDL.bind(this);
        this.onChange = this.onChange.bind(this);
        this.state = {
            action: 0,
            modalClose: false,
            reportId: "",
            title: "",
            processing: reportStore.getState().processing,
        };
    }
    static defaultProps = {
        mthTxt: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        dayTxt: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        severityTxt: ["Low", "Medium", "High", "Critical"],
        statusTxt: ["Closed", "Open", "Removed"],
        roleTxt: [
            "Administrative Executive", "Property Executive", "Property Manager", "Human Resource Executive",
            "Contracts Management Executive", "Accounts Executive", "Accounts Manager", "Information Technology",
            "Managing Director", "Director", "Other", "Cleaner Supervisor", "Cleaner", "Landscaper", "Electrician", "Caretaker",
            "Portfolio Manager", "Team Manager", "Senior Admin Executive"
        ],
    }
    componentDidMount() {
        reportStore.listen(this.onChange);
    }
    componentWillUnmount() {
        reportStore.unlisten(this.onChange);
    }
    onChange(state) {
        this.setState({
            processing: state.processing
        })
    }
    handlePrint() {
        window.print();
    }
    handleDL() {
        if (this.state.processing) return;

        reportAction.processing(true);
        reportAction.downloadPDFfile(this.props.reportDetail.reportNo);
    }
    handleOption(e) {
        e.preventDefault();
        e.stopPropagation();

        let action = parseInt(e.currentTarget.getAttribute("data-action"));
        let reportId = e.currentTarget.getAttribute('data-id');

        let title;
        if (action == 0) {
            title = "Extend Target Date";
        } else if (action == 1) {
            title = "Resolution";
        } else if (action == 2) {
            title = "Add Remark";
        } else {
            title = "Delete Incident";
        }

        this.setState({
            action: 0,
            modalClose: true,
            reportId: reportId,
            action: action,
            title: title
        });
    }

    extendIncident(day, reason, clientEmail, reportImage) {
        if (this.state.processing) return;
        reportAction.processing(true);
        let fd = new FormData();
        fd.append("day", day);
        fd.append("reason", reason);
        if (clientEmail) {
            if (clientEmail.length > 0) {
                for (let i = 0; i < clientEmail.length; i++) {
                    fd.append("clientEmail[]", clientEmail[i]);
                }
            }
        }
        if (reportImage) {
            if (reportImage.length > 0) {
                for (let i = 0; i < reportImage.length; i++) {
                    fd.append("images", reportImage[i]);
                }
            }
        }
        reportAction.extendIncident(this.state.reportId, fd);
        this.shouldModalClose(false);
    }
    resolveIncident(resolution, value, clientEmail, reportImage) {
        if (this.state.processing) return;
        reportAction.processing(true);
        let fd = new FormData();
        fd.append("resolution", resolution);
        if (clientEmail) {
            if (clientEmail.length > 0) {
                for (let i = 0; i < clientEmail.length; i++) {
                    fd.append("clientEmail[]", clientEmail[i]);
                }
            }
        }
        if (reportImage) {
            if (reportImage.length > 0) {
                for (let i = 0; i < reportImage.length; i++) {
                    fd.append("images", reportImage[i]);
                }
            }
        }
        reportAction.resolveIncident(this.state.reportId, fd);
        this.shouldModalClose(false);
    }
    addingRemark(remark, value, clientEmail, reportImage) {
        if (this.state.processing) return;
        reportAction.processing(true);

        let fd = new FormData();
        fd.append("remark", remark);
        if (clientEmail) {
            if (clientEmail.length > 0) {
                for (let i = 0; i < clientEmail.length; i++) {
                    fd.append("clientEmail[]", clientEmail[i]);
                }
            }
        }
        if (reportImage) {
            if (reportImage.length > 0) {
                for (let i = 0; i < reportImage.length; i++) {
                    fd.append("images", reportImage[i]);
                }
            }
        }
        reportAction.addingRemark(this.state.reportId, fd);
        this.shouldModalClose(false);
    }
    removeIncident() {
        if (this.state.processing) return;
        reportAction.processing(true);
        reportAction.removeIncident(this.state.reportId);
        this.shouldModalClose(false);
    }
    shouldModalClose(data) {
        this.setState({
            modalClose: data
        });
    }
    renderExtend() {
        if (!this.props.reportDetail.extend) return;

        let extend = this.props.reportDetail.extend.map((extend, index) => {
            return (
                <div className="ext" key={index}>
                    <h5><b>Extension {index + 1}</b></h5>
                    <div className="ext-wp">
                        <div className="det-tt">No of days :</div>
                        <div className="det-ct">{extend.day}</div>
                    </div>
                    <div className="ext-wp">
                        <div className="det-tt">Reason:</div>
                        <div className="det-ct">{extend.reason}</div>
                    </div>
                    <div className="ext-wp">
                        <div className="det-tt">Extended By :</div>
                        <div className="det-ct">{extend.userName}</div>
                    </div>
                </div>
            )
        });
        return extend;
    }
    renderRemark() {
        if (!this.props.reportDetail.remarks || this.props.reportDetail.remarks.length == 0) return;

        let remark = this.props.reportDetail.remarks.map((remark, index) => {
            return (
                <div className="rmk-wp" key={index}>
                    <div className="rmk-ct">{index + 1}. {remark.remark} <b>by {remark.userName}</b></div>
                </div>
            );
        });
        return (
            <div className="ext">
                <h5><b>Remark:</b></h5>
                {remark}
            </div>
        );

    }
    renderEmail() {
        let staffEmail = "", contractorEmail, clientEmail = "";
        if (this.props.reportDetail.email) {
            staffEmail = this.props.reportDetail.email.map((email, index) => {
                let list = email.userName + " (" + this.props.roleTxt[email.role] + ")";
                return (index == 0 ? list : " " + list);
            });
        }
        /*
        if (this.props.reportDetail.contractors) {
            contractorEmail = this.props.reportDetail.contractors.map((contractor, index) => {
                return (" " + contractor.contractorName);
            });
        }
        */
        if (this.props.reportDetail.clientEmail && this.props.reportDetail.clientEmail != null) {
            clientEmail = this.props.reportDetail.clientEmail.map((email, index) => {
                return (", " + email);
            });
        }

        return staffEmail + (clientEmail != "" ? clientEmail : "");
    }

    render() {
        let detail = this.props.reportDetail;
        detail.date = detail.date ? new Date(detail.date) : "";
        detail.targetDate = detail.targetDate ? new Date(detail.targetDate) : "";
        detail.completionDate = detail.status == 0 && detail.completionDate ? new Date(detail.completionDate) : "";
        let date = detail.date ?
            (detail.date.getDate() + "-" + this.props.mthTxt[detail.date.getMonth()] + "-" + detail.date.getFullYear())
            : "-";
        let day = detail.date ? this.props.dayTxt[detail.date.getDay()] : "-";
        let callBack;

        if (this.state.action == 0) {
            callBack = this.extendIncident;
        } else if (this.state.action == 1) {
            callBack = this.resolveIncident;
        } else if (this.state.action == 2) {
            callBack = this.addingRemark;
        } else {
            callBack = this.removeIncident;
        }

        let completeDate = "";
        if (detail.status == 0) {
            if (detail.completionDate) {
                completeDate = detail.completionDate.getDate() + "-" + this.props.mthTxt[detail.completionDate.getMonth()] + '-' +
                    detail.completionDate.getFullYear();
            }
        } else {
            if (detail.targetDate) {
                completeDate = detail.targetDate.getDate() + "-" + this.props.mthTxt[detail.targetDate.getMonth()] + "-" +
                    detail.targetDate.getFullYear();
            }
        }

        let modal;
        if (this.state.modalClose) {
            modal = (
                <ReportModal
                    action={this.state.action}
                    callBack={callBack}
                    shouldModalClose={this.shouldModalClose}
                    modalClose={this.state.modalClose}
                    title={this.state.title}
                    clientEmail={this.props.reportDetail.clientEmail}
                />
            );
        }
        return (

            <div id="detailReport">
                <h1>Incident Report</h1>

                <div className="row">
                    <div className="col-sm-6">
                        <div className="det-wp">
                            <div className="det-tt">Report No :</div>
                            <div className="det-ct">{detail.reportNo}</div>
                        </div>
                        <div className="det-wp">
                            <div className="det-tt">Date :</div>
                            <div className="det-ct">{date}</div>
                        </div>
                        <div className="det-wp">
                            <div className="det-tt">Day :</div>
                            <div className="det-ct">{day}</div>
                        </div>
                        <div className="det-wp">
                            <div className="det-tt"><b>Condo :</b></div>
                            <div className="det-ct"><b>{detail.condoName} ({detail.mcst})</b></div>
                        </div>
                        <div className="det-wp">
                            <div className="det-tt"><b>Area :</b></div>
                            <div className="det-ct"><b>{detail.facility}</b></div>
                        </div>
                        <div className="det-wp">
                            <div className="det-tt">Category :</div>
                            <div className="det-ct">{detail.category}</div>
                        </div>
                    </div>

                    <div className="col-sm-6">
                        <div className="det-wp">
                            <div className="det-tt">Submitted By :</div>
                            <div className="det-ct">{detail.userName}</div>
                        </div>
                        <div className="det-wp">
                            <div className="det-tt">Severity :</div>
                            <div className="det-ct">{this.props.severityTxt[detail.severity]}</div>
                        </div>
                        <div className="det-wp">
                            <div className="det-tt"><b>Status :</b></div>
                            <div className="det-ct"><b>{this.props.statusTxt[detail.status]}</b></div>
                        </div>
                        <div className="det-wp">
                            <div className="det-tt"><b>{detail.status == 0 ? "Completion Date :" : "Target Completion Date :"}</b></div>
                            <div className="det-ct"><b>{completeDate}</b></div>
                        </div>
                        <div className="det-wp">
                            <div className="det-tt">{detail.status == 2 ? "Removed Reason" : "Resolution"} :</div>
                            <div className="det-ct">{detail.resolution}</div>
                        </div>
                        <div className="det-wp">
                            <div className="det-tt">{detail.status == 2 ? "Removed By" : "Resolved By"} :</div>
                            <div className="det-ct">{detail.resolvedBy}</div>
                        </div>
                        <div className="det-wp">
                            <div className="det-tt">Email To :</div>
                            <div className="det-ct">{this.renderEmail()}</div>
                        </div>
                    </div>
                </div>
                <div className="row" id="det-2nd">
                    <div className="col-sm-4">
                        <div className="det-imp-wp">
                            <img src={detail.reportImage ? detail.reportImage[0] : ""} className="det-img" />
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <div className="det-imp-wp">
                            <img src={detail.reportImage ? detail.reportImage[1] : ""} className="det-img" />
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <div className="det-imp-wp">
                            <img src={detail.reportImage ? detail.reportImage[2] : ""} className="det-img" />
                        </div>
                    </div>
                </div>
                <div className="row" id="det-3rd">
                    <div className="col-sm-6">
                        <h5><b>Description :</b></h5>
                        <div className="det-des-ct">
                            {detail.description}
                        </div>
                        {this.renderRemark()}
                    </div>
                    <div className="col-sm-6">
                        {this.renderExtend()}
                    </div>
                </div>
                <div className="row" id="det-4th">
                    <div className="col-sm-12">
                        <div className="det-btn-grp">
                            {<div className="det-btn-tt">Action:</div>}
                            <button className="btn btn-default" onClick={this.handlePrint}>Print</button>
                            <button className="btn btn-default" onClick={this.handleDL}>Download</button>
                            {detail.status == 1 ? <button className="btn btn-default" data-action="0" data-id={detail._id} onClick={this.handleOption}>Extend Target Date</button> : ""}
                            {detail.status == 1 ? <button className="btn btn-default" data-action="1" data-id={detail._id} onClick={this.handleOption}>Resolved</button> : ""}
                            {detail.status == 1 ? <button className="btn btn-default" data-action="2" data-id={detail._id} onClick={this.handleOption}>Add Remark</button> : ""}
                        </div>
                    </div>
                </div>
                <Loading processing={this.state.processing} />
                {modal}
            </div>
        );
    }
}
export default ReportDetail;


// WEBPACK FOOTER //
// ./app/components/reportComponents/detailContent.js